import { ABOUT } from "../data/content";
import { Reveal } from "./Reveal";

export const About = () => (
    <section
        id="tentang"
        data-testid="tentang-section"
        aria-labelledby="tentang-title"
        className="bg-white py-24 sm:py-32 scroll-mt-20"
    >
        <div className="max-w-[1565px] mx-auto px-6 sm:px-8 grid lg:grid-cols-12 gap-14 items-center">
            <div className="lg:col-span-7">
                <Reveal>
                    <p className="text-xs font-semibold uppercase tracking-[0.28em] text-bh-gold mb-4">
                        {ABOUT.eyebrow}
                    </p>
                    <h2
                        id="tentang-title"
                        data-testid="tentang-title"
                        className="font-serif font-bold text-2xl sm:text-3xl lg:text-4xl text-bh-deep tracking-tight mb-8"
                    >
                        {ABOUT.title}
                    </h2>
                    <span aria-hidden="true" className="block w-14 h-[2px] bg-bh-gold mb-10" />
                </Reveal>
                <Reveal delay={0.12}>
                    <blockquote
                        data-testid="tentang-statement"
                        className="border-l-2 border-bh-gold pl-7 sm:pl-9"
                    >
                        <p className="font-serif text-lg sm:text-xl lg:text-2xl leading-relaxed text-bh-ink/90">
                            “
                            {ABOUT.statement.map((segment, i) => (
                                <span
                                    key={i}
                                    className={segment.newParagraph ? "block mt-6" : undefined}
                                >
                                    {segment.bold ? (
                                        <strong className="font-bold text-bh-deep">
                                            {segment.text}
                                        </strong>
                                    ) : (
                                        segment.text
                                    )}
                                    {i === ABOUT.statement.length - 1 && "”"}
                                </span>
                            ))}
                        </p>
                    </blockquote>
                </Reveal>
            </div>
            <Reveal delay={0.2} className="lg:col-span-5">
                <div
                    data-testid="tentang-photo-placeholder"
                    className="relative aspect-square overflow-hidden rounded-xl border border-bh-green/15 bg-bh-light"
                >
                    <img
                        src="/assets/Image-tentang.webp"
                        alt="Gedung PPTQ Baitul Haq Trenggalek dengan santri di halaman pesantren"
                        className="absolute inset-0 h-full w-full object-cover"
                        loading="lazy"
                    />
                </div>
            </Reveal>
        </div>
    </section>
);
